module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Hemmiken-95d2b2884db1b4f7140fd0378f7fb633.svg";